import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { map } from "rxjs/operators";
import { apiConstants } from "../constant/apiConstant";

@Injectable()
export class SchoolDetailsService {
  private url = AppSettings.API_ENDPOINT_V3;
  private getInstituteTypes = apiConstants.getInstituteTypes;
  private addInstituteInformationDetails =
    apiConstants.addInstituteInformationDetails;
  constructor(private http: HttpClient) { }
  headers: HttpHeaders;

  getInstituteTypesApi(authToken) {
    const headers = new HttpHeaders().append("token", authToken);
    return this.http
      .get(`${this.url}${this.getInstituteTypes}`, { headers })
      .pipe(map((res) => res));
  }

  addInstituteInformationDetailsApi(body: any, authToken: string) {
    const headers = new HttpHeaders().append("token", authToken);
    return this.http
      .post(`${this.url}${this.addInstituteInformationDetails}`, body, {
        headers,
      })
      .pipe(map((res) => res));
  }
}
